import React from 'react';
import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { ContextProvider } from './Context';

import Main from './Main';

export default function Index() {
  return (
    <ContextProvider>
      <UsersContextProvider>
        <Main />
      </UsersContextProvider>
    </ContextProvider>
  );
}
